import React, { useCallback, useEffect, useRef, useState } from 'react';

/**
 * UNA TABLA QUE SE VA DE LADO, Y QUE LO DICE (Jesús, punto 51).
 *
 * Su frase: «la primera columna no está fijada... y una señal de que hay más a los lados».
 * La columna fija ya estaba; la señal no. Lo único que había era la barra gris finísima del
 * navegador, que en un móvil ni se ve, así que la columna más importante -- «Total» en la
 * tabla del equipo -- se quedaba fuera sin que nadie supiera que estaba ahí.
 *
 * La señal es una sombra en el borde por el que queda tabla, y se apaga sola cuando ya no
 * queda: una sombra permanente sería otra decoración, y lo que tiene que hacer es decir
 * algo. Se mira al montar, al desplazar y al cambiar el ancho de la ventana.
 *
 * `fondo` es el color desde el que degrada, y tiene que ser el de la tarjeta que hay
 * detrás: con el fondo equivocado la sombra se ve como una banda pegada.
 */
const TablaDeslizable = ({ children, className = '', fondo = 'from-card' }) => {
    const caja = useRef(null);
    const [hayIzquierda, setHayIzquierda] = useState(false);
    const [hayDerecha, setHayDerecha] = useState(false);

    const medir = useCallback(() => {
        const e = caja.current;
        if (!e) return;
        // El margen de un píxel es por los anchos con decimales: sin él, una tabla que cabe
        // justa se pasa la vida diciendo que le queda algo a la derecha.
        setHayIzquierda(e.scrollLeft > 1);
        setHayDerecha(e.scrollLeft + e.clientWidth < e.scrollWidth - 1);
    }, []);

    useEffect(() => {
        medir();
        window.addEventListener('resize', medir);
        return () => window.removeEventListener('resize', medir);
    }, [medir, children]);

    return (
        <div className="relative">
            <div ref={caja} onScroll={medir} className={`overflow-x-auto ${className}`}
                data-testid="tabla-deslizable">
                {children}
            </div>
            {hayIzquierda && (
                <div aria-hidden="true" data-testid="tabla-hay-izquierda"
                    className={`pointer-events-none absolute inset-y-0 left-0 w-7 bg-gradient-to-r ${fondo} to-transparent`} />
            )}
            {hayDerecha && (
                <div aria-hidden="true" data-testid="tabla-hay-derecha"
                    className={`pointer-events-none absolute inset-y-0 right-0 w-7 bg-gradient-to-l ${fondo} to-transparent`} />
            )}
        </div>
    );
};

export default TablaDeslizable;
